const CHAVE = 'tokenUrl';

export const obterTokenUrl = (search: string): string | null =>
  new URLSearchParams(search).get('token') || sessionStorage.getItem(CHAVE);

export const descartarTokenUrl = (): void => sessionStorage.removeItem(CHAVE);
